/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_AmountInputs */

const vi_customer_debt_payment_amount = /** @type {(inputs: Customer_Debt_Payment_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền`)
};

/**

* @param {Customer_Debt_Payment_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_amount = /** @type {((inputs?: Customer_Debt_Payment_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_amount(inputs)
});